import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CustomButton } from "components/Button";

interface AuditVideoPopupProps {
    open: boolean;
    handleClose: () => void;
    videoUrl: string | null;
}

export default function AuditVideoPopup({ open, handleClose, videoUrl }: AuditVideoPopupProps) {
    if (!open || !videoUrl) {
        return null;
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '52vw', maxWidth: 900, gap: 1.5, mt: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <CustomButton
                    variant="outlined"
                    size="small"
                    onClick={handleClose}
                    startIcon={<CloseIcon fontSize="small" />}
                >
                    Close
                </CustomButton>
            </Box>
            <Box
                component="video"
                src={videoUrl}
                controls
                autoPlay
                preload="metadata"
                sx={{
                    width: '100%',
                    maxHeight: '70vh',
                    backgroundColor: '#000',
                    borderRadius: '8px',
                }}
            />
        </Box>
    );
}
